/* Claude 4.52 — "Back" badge follows the variant the card is showing.

   card-product.liquid renders the Back badge on a card only when at least one
   of its variants came back from zero (variant metafield claude.back_since,
   maintained by the daily "New" + "BackIn" tags task). The badge carries
   data-back-ids=",id,id," and starts visible only if the card's default
   variant is one of them. This script keeps it honest as the shopper moves
   around the swatch row:
     · hover a swatch          → badge shows only if THAT variant is back
     · leave the swatch row    → back to the selected swatch, or the default
     · tap/select a swatch     → follows the selection (card-swatch-select.js)
   A combined-listing sibling swatch is another product, so it hides the badge;
   so does a swatch whose variant is discounted (data-variant-compare), because
   Back never shows when there is a discount to show.
   Loaded only from cards that have a Back badge; guarded so it runs once. */
(function () {
  if (window.__claudeBackBadge) return;
  window.__claudeBackBadge = true;

  var SW = '.card-swatches__swatch';

  function badgeOf(card) {
    return card ? card.querySelector('.badge-back-in-stock') : null;
  }
  function variantIdOf(sw) {
    if (sw.hasAttribute('data-sibling-url')) return null;
    var m = (sw.getAttribute('href') || '').match(/[?&]variant=(\d+)/);
    return m ? m[1] : null;
  }
  function setVisible(badge, on) {
    badge.style.display = on ? '' : 'none';
  }
  function showFor(sw) {
    var card = sw.closest('.card-wrapper');
    var badge = badgeOf(card);
    if (!badge) return;
    var id = variantIdOf(sw);
    var ids = badge.getAttribute('data-back-ids') || '';
    var on = !!id && ids.indexOf(',' + id + ',') !== -1 && !sw.hasAttribute('data-variant-compare');
    setVisible(badge, on);
  }
  function restore(card) {
    var badge = badgeOf(card);
    if (!badge) return;
    var current = card.querySelector(SW + '[aria-current="true"]');
    if (current) { showFor(current); return; }
    setVisible(badge, badge.getAttribute('data-back-default') === '1');
  }

  document.addEventListener('mouseover', function (e) {
    var sw = e.target.closest && e.target.closest(SW);
    if (sw) showFor(sw);
  });
  document.addEventListener('mouseout', function (e) {
    var sw = e.target.closest && e.target.closest(SW);
    if (!sw) return;
    var to = e.relatedTarget;
    if (to && to.closest && to.closest(SW)) return;
    restore(sw.closest('.card-wrapper'));
  });
  /* card-swatch-select.js toggles aria-current in its own capture-phase
     click handler; read the result on the next tick. */
  document.addEventListener('click', function (e) {
    var sw = e.target.closest && e.target.closest(SW);
    if (!sw) return;
    var card = sw.closest('.card-wrapper');
    setTimeout(function () { if (card) restore(card); }, 0);
  }, true);
})();
